<template>
  <div id="debit_1372">
    <AddEntity
      ref="addEntity"
      entity-name="debit"
      :fields-to-hide="fieldsToHide"
      :display-button="false"
      @refresh="
        $store.dispatch(`${namespace}/fetchData`);
        $emit('refresh');
      "
    />
    <b-row>
      <b-col
        id="budget_ars"
        cols="4"
      >
        <strong>Budget ARS&nbsp;: </strong>
        <output>{{ budgetArs | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col
        id="amount_obligated"
        cols="4"
      >
        <strong>Amount obligated&nbsp;: </strong>
        <output>{{ amountObligated | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col
        id="amount_available"
        cols="4"
      >
        <strong>Amount available&nbsp;: </strong>
        <output>{{ amountAvailable | moneyFilter }}&nbsp;$</output>
      </b-col>
      <b-col cols="12">
        <GenericTable
          ref="genericTableDebit1372"
          endpoint-url="/debit"
          :name="namespace"
          :actions="actions"
          :colonnes="colonnes"
          :filterable-col="filterableCol"
          :extra-filters="extraFilters"
          :display-archive-checkbox="false"
          right-button
          @action-callback="dispatchAction"
          @row-click="clickRow"
        >
          <button
            class="btn right-button"
            @click="exportSimple"
          >
            Exporter tous les débits 1372
          </button>
        </GenericTable>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";

import mixinBudget from "@/mixins/mixinBudget";

import { roundNumber } from "@/modules/utils";
import { moneyFilter, spaceNumber } from "@/modules/filters";

export default {
  name: "Debit1372",
  components: { GenericTable },
  mixins: [mixinBudget],
  data() {
    return {
      namespace: "Budget1372Debit",
      colonnes: [
        { key: "etape" },
        { key: "prestation" },
        { key: "tirage__ouvrage__auteurs_verbose", overrideName: "Auteurs" },
        { key: "vendeur__nom", overrideName: "Fournisseur" },
        { key: "date_demande", overrideName: "Date demande PR", defaultOrder: true },
        { key: "numero_demande_pr", overrideName: "N° demande PR" },
        { key: "po" },
        { key: "date_po" },
        { key: "engage_fr" },
        { key: "engage_us" },
        { key: "paye_fr" },
        { key: "paye_us" },
      ],
      filterableCol: [
        "tirage__nom",
        "prestation",
        "etape",
        "numero_demande_pr",
        "budget",
        "date_demande",
        "po",
        "vendeur__nom",
      ],
      fieldsToHide: [
        "tirage",
        "quantite",
        "quantite_droit",
        "budget_impression",
        "is_achat",
        "fournisseur",
      ],
    };
  },
  computed: {
    extraFilters() {
      if (this.annee === null) {
        return {
          budget: 1372,
          date_po__isnull: true,
        };
      }
      return {
        budget: 1372,
        date_po__gte: `01/10/${this.annee - 1}`,
        date_po__lte: `30/09/${this.annee}`,
      };
    },
    budgetArs() {
      return roundNumber(this.infoBudgets[1372].credits);
    },
    amountObligated() {
      return roundNumber(this.infoBudgets[1372].debits);
    },
    amountAvailable() {
      return roundNumber(
        this.infoBudgets[1372].credits - this.infoBudgets[1372].debits,
      );
    },
  },
  mounted() {
    this.$store.commit(
      `${this.namespace}/setFormatDataFunction`,
      this.verboseColDebitForTable,
    );
  },
  methods: {
    /**
     * Met en forme les données du tableau des débits.
     * @public
     * @param {Object} data Données du tableau.
     */
    verboseColDebitForTable(data) {
      const { results } = data;

      results.forEach((ligne) => {
        ligne.engage_fr_verbose = spaceNumber(ligne.engage_fr);
        ligne.engage_us_verbose = moneyFilter(ligne.engage_us);
        ligne.paye_fr_verbose = moneyFilter(ligne.paye_fr);
        ligne.paye_us_verbose = moneyFilter(ligne.paye_us);

        if (ligne.is_achat) {
          ligne.vendeur = ligne.fournisseur;
        }
      });
    },
    clickRow(row) {
      if (row.is_achat) {
        this.fieldsToHide.push("vendeur");
        this.fieldsToHide.push("tirage");
      } else {
        this.fieldsToHide = this.fieldsToHide.filter((e) => e !== "vendeur" && e !== "tirage");
      }

      this.openDetails(row);
    },
  },
};
</script>

<style lang="scss">
#debit_1372 .table-content {
  .etape { width: 150px; }

  .prestation { min-width: 200px; }

  .vendeur__nom { min-width: 100px; }

  .date_demande,
  .date_po { width: 100px; }

  .numero_demande_pr { width: 100px; }

  .po { width: 100px; }

  .engage_fr,
  .engage_us,
  .paye_fr,
  .paye_us { width: 90px; }
}
</style>
